/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {InputDate} from '../../../../../components/UI/Input'
import {Select} from '../../../../../components/UI/Select'
import {SelectOption} from '../../../../../models/utility.model'
import {ratioOccupancyCustomerSchema} from '../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {
  RatioOccupancyBedStatusData,
  RatioOccupancyByCostumerDto,
  RatioOccupancyCostumerData,
} from '../../../models/reports.model'
import {
  getRatioOccupancyByBedStatusService,
  getRatioOccupancyByCustomerService,
} from '../../../services/ratio.service'
import {TableReportRatioOccupancyByBedStatusWrapper} from './Tables/TableReportRatioOccupancyByBedStatus'
import {TableReportRatioOccupancyByCustomerWrapper} from './Tables/TableReportRatioOccupancyByCustomer'
import {TableReportRatioOccupancyByCompanyWrapper} from './Tables/TableReportRatioOccupancyByCompany'

const RatiosOccupancy: FC = () => {
  const methods = useForm<RatioOccupancyByCostumerDto>({
    resolver: yupResolver(ratioOccupancyCustomerSchema),
    defaultValues: {
      CampamentoId: '',
    },
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    watch,
    reset,
  } = methods
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [loadingCustomer, setLoadingCustomer] = useState<boolean>(false)
  const [loadingBed, setLoadingBed] = useState<boolean>(false)
  const [total, setTotal] = useState<number>(0)
  const [dataByCostumer, setDataByCosumter] = useState<RatioOccupancyCostumerData[]>([])
  const [dataByBed, setDataByBed] = useState<RatioOccupancyBedStatusData[]>([])
  const [dtoByCostumer, setDtoByCostumer] = useState<any>(null)
  const [dtoByBed, setDtoByBed] = useState<any>(null)

  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()
  ///

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    setSite(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCamp(allData)
  }

  useEffect(() => {
    getCompaniesFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getOccupancyByCostumer = async (datafilter: any = {}) => {
    try {
      setLoadingCustomer(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const formValue = {pageNumber: 1, size: 10, ...obj, ...datafilter}
      setDtoByCostumer(formValue)
      const {data: response} = await getRatioOccupancyByCustomerService(formValue)
      if (!response.error) {
        let totalItemByCustomer: RatioOccupancyCostumerData = {
          CampamentoNombre: 'TOTALES',
          Cliente: response.TotalCliente,
          SSEE: response.TotalSSEE,
          Sodexo: response.TotalSodexo,
          Total: response.TotalTotal,
          Diferencia: response.TotalDiferencia,
          CapacidadAlojamiento: response.TotalCapacAlojamiento,
          CamasCalientes: response.TotalCamasCalientes,
          CamasInstaladas: response.TotalCamasInstaladas,
          TotalRES:response.TotalTotalRES
        }
        let arrCostumer =
          response.data.length > 0 ? [...response.data, totalItemByCustomer] : response.data
        setDataByCosumter(arrCostumer)
        setTotal(response.total)
        setLoadingCustomer(false)
      }
    } catch (error) {
      setLoadingCustomer(false)
    }
  }

  const getOccupancyByBed = async (datafilter: any = {}) => {
    try {
      setLoadingBed(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const formValue = {pageNumber: 1, size: 10, ...obj, ...datafilter}
      setDtoByBed(formValue)
      const {data: response} = await getRatioOccupancyByBedStatusService(formValue)
      if (!response.error) {
        setDataByBed(response.data)
        setLoadingBed(false)
      }
    } catch (error) {
      setLoadingBed(false)
    }
  }

  const onSubmit = (dataForm: any) => {
    getOccupancyByCostumer()
    getOccupancyByBed()
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
    setClient([])
    setSite([])
    setCamp([])
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setSite([])
    setCamp([])
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('CampamentoId', '')
    getCampsFn(value)
    setValue('SiteId', value)
    setError('SiteId', {})
    setCamp([])
  }

  const handleChangeDate = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('Fecha', value)
    setError('Fecha', {})
  }

  const handleClear = () => {
    reset()
    setClient([])
    setSite([])
    setCamp([{value: '', label: 'TODOS'}])
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Compañía:</label>
                  <Select
                    control={control}
                    name='CompaniaId'
                    data={compani}
                    errors={errors}
                    onChangeValue={handleFilterClient}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Cliente:</label>
                  <Select
                    control={control}
                    name='ClienteId'
                    data={client}
                    errors={errors}
                    onChangeValue={handleFilterSite}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Site:</label>
                  <Select
                    control={control}
                    name='SiteId'
                    data={site}
                    errors={errors}
                    onChangeValue={handleFilterCamp}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Campamento:</label>
                  <Select control={control} name='CampamentoId' data={camp} errors={errors} />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Fecha :</label>
                  <InputDate
                    name='Fecha'
                    register={register}
                    errors={errors}
                    onChange={handleChangeDate}
                    maxValue={moment().format('YYYY-MM-DD')}
                  />
                </div>
              </div>
              {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                <Button label='Limpiar' onClick={handleClear} />
              </ButtonWrapper>
            </form>
          </FormProvider>
        </div>
        <div className='sdx_content_tab_panel'>
          <Tabs className={'sdx_sub_react_tab_panel '}>
            <TabList className={'sdx_sub_tab_panel p-0'}>
              <Tab className={'sdx_sub_tab_panel_option'}>Campamento</Tab>
              <Tab className={'sdx_sub_tab_panel_option'}>Capacidad de Alojamiento</Tab>
              {/* <Tab className={'sdx_sub_tab_panel_option'}>Capacidad de Alojamiento</Tab> */}
            </TabList>
            <TabPanel>
              <TableReportRatioOccupancyByCustomerWrapper
                datos={dataByCostumer}
                loading={loadingCustomer}
                getOccupancy={getOccupancyByCostumer}
                total={total}
                formValue={dtoByCostumer}
              />
            </TabPanel>
            <TabPanel>
              <TableReportRatioOccupancyByBedStatusWrapper
                datos={dataByBed}
                formValue={dtoByBed}
                loading={loadingBed}
              />
            </TabPanel>
            {/* <TabPanel>
              <TableReportRatioOccupancyByCompanyWrapper
                datos={dataByBed}
                formValue={dtoByBed}
                loading={loadingBed}
              />
            </TabPanel> */}
          </Tabs>
        </div>
      </KTCard>
    </>
  )
}

export {RatiosOccupancy}
